export default {
  methods: {
    getStatutSession(value) {
      let statut = '';
      switch (value) {
        case 0:
          statut = 'Envisagé';
          break;
        case 1:
          statut = 'Confirmé';
          break;
        case 2:
          statut = 'Realisé';
          break;
        case 3:
          statut = 'Annulé';
          break;
        case 4:
          statut = 'Encours';
          break;
        case 5:
          statut = 'Archivé';
          break;
      }
      return statut;
    },
    getReponseParticipation(value) {
      let statut = '';
      switch (value) {
        case 0:
          statut = 'En attente';
          break;
        case 1:
          statut = 'Acceptée';
          break;
        case 2:
          statut = 'Refusée';
          break;
      }
      return statut;
    },
    getStatutPresence(value) {
      let statut = '';
      switch (value) {
        case 0:
          statut = 'Absent(e)';
          break;
        case 1:
          statut = 'Présent(e)';
          break;
      }
      return statut;
    },
  },
};
